import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var BasketballBall = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 512 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M86.6 64c32.4-28.5 72-49 115.7-58.4C206 19.1 208 33.3 208 48c0 38.4-13.5 73.7-36.1 101.3L86.6 64zM64 86.6l85.2 85.2C121.7 194.5 86.4 208 48 208c-14.7 0-28.9-2-42.4-5.7C15 158.6 35.5 119 64 86.6zM256 0c64.9 0 124.2 24.2 169.4 64L256 233.4 194.6 172C222.9 138.5 240 95.3 240 48c0-16.2-2-32-5.8-47.1A263 263 0 0 1 256 0zM48 240c47.3 0 90.5-17.1 124-45.4l61.4 61.4L64 425.4C24.2 380.2 0 320.9 0 256c0-7.3.3-14.6.9-21.8C16 238 31.8 240 48 240zm463.1 37.8C496 274 480.2 272 464 272c-47.3 0-90.5 17.1-124 45.4L278.6 256 448 86.6c39.8 45.1 64 104.4 64 169.4 0 7.3-.3 14.6-.9 21.8zm-4.7 31.9C497 353.4 476.5 393 448 425.4l-85.2-85.2C390.3 317.5 425.6 304 464 304c14.7 0 28.9 2 42.4 5.7zm-166.3 53 85.3 85.3c-32.4 28.5-72 49-115.7 58.4-3.7-13.5-5.7-27.7-5.7-42.4 0-38.4 13.5-73.7 36.1-101.3zM317.4 340c-28.3 33.5-45.4 76.7-45.4 124 0 16.2 2 32 5.8 47.1-7.2.6-14.5.9-21.8.9-64.9 0-124.2-24.2-169.4-64L256 278.6l61.4 61.4z"
  }));
});
BasketballBall.displayName = 'BasketballBall';
export var BasketballBallDimensions = {
  height: 512,
  width: 512
};